import React from 'react';
import {makeStyles} from '@mui/styles';
import Snackbar from '@/components/Snackbar';
import Confetti from 'react-dom-confetti';
import snackbarContext from '@/contexts/Snackbar';

const confettiConfig = {
  angle: 90,
  spread: 75,
  startVelocity: 35,
  elementCount: 130,
  dragFriction: 0.15,
  duration: 2070,
  stagger: 1,
  width: '7px',
  height: '5px',
  perspective: '1000px',
  colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
};

const useStyles = makeStyles({
  confettiContainer: {
    position: 'fixed',
    alignItems: 'flex-end',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    zIndex: 100000,
    display: 'none',
    bottom: 40,
  },
  displayFlex: {
    display: 'flex',
  },
});

const SnackbarAndConfetti = () => {
  const styles = useStyles();
  const {snackbarItem, setSnackbarItem} = React.useContext(snackbarContext);

  return (
    <>
      <div
        className={`${styles.confettiContainer} ${
          Boolean(snackbarItem?.withConfetti) &&
          snackbarItem?.severity === 'success'
            ? styles.displayFlex
            : ''
        }`}
      >
        <Confetti
          active={
            Boolean(snackbarItem?.withConfetti) &&
            snackbarItem?.severity === 'success'
          }
          config={confettiConfig}
        />
      </div>
      <Snackbar
        open={Boolean(snackbarItem)}
        setClosed={() => setSnackbarItem(null)}
        message={snackbarItem?.message || null}
        severity={snackbarItem?.severity}
      />
    </>
  );
};

export default SnackbarAndConfetti;
